// extracted by mini-css-extract-plugin
module.exports = {"items":"WhyChooseUs_items__A5yS8","item":"WhyChooseUs_item__9CKnU"};